import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import closeoutsService from '../../services/closeoutsService';
import cancelIcon from '../../assets/images/close-icon.svg';

import anime from 'animejs';
import dataModel from '../../models/DataModel';

import './FileNamePopup.scss';
import Input from '../Input';

export class FileNamePopUp extends BaseComponent {
  constructor(props){
    super(props);
    
    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.changeFileName = this.changeFileName.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    
    this.state = {
      fileName: this.props.initialName,
      change: false,
      selectedTab: this.props.actualTab,
    };
  
  }

  changeFileName(e) {
    let value = e.target.value;
    let textName= value.replace(/[&\/\\#,+()$~%.'":*?<>{}!¡]/g, '');
    const name = textName;
    this.setState({ fileName: name , change: true });
    this.props.onChange(textName);
    this.props.handleResetFileName(true);
   
  }

  componentDidMount() {
    // it should be true but it disables the pop up
    if (this.props.popupUbication=='projectCloseout'){
      dataModel.setDisableAppBackground(true);
    }
   
  }

  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  collapsePopup(e, force) {
    // let name=this.props.staticName
    this.props.onChange(this.props.staticName);
   
    this.props.handleResetFileName(false);
    this.state.change=false;
    this.setState({ fileName: this.props.staticName });
    if (!this.props.popupUbication){this.props.handleDownload();}
    
    return anime({
      targets: this.deactivatePopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
   
  }

  extractType(url) {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname;

    const cleanPath = path.endsWith('/') ? path.slice(0, -1) : path;

    const segments = cleanPath.split('/');
    return segments.pop();
  }

  handleDownloadFile(fileUrl) {
    if (!fileUrl) {
      this.collapsePopup();
      return;
    }
    if (!this.state.change) {
      this.props.onChange(this.state.fileName);
    }
    this.props.handleResetFileName(false);
    this.state.change = false;
    const reportType = this.extractType(fileUrl);
    if ((this.props.which === 'closeouts' && this.props.tab === 'closeout history') || reportType === 'zip-closeouts') {
      closeoutsService.getZipCloseout(fileUrl);
    } else {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', this.state.fileName);
      document.body.appendChild(link);
      link.click();
    }
    this.collapsePopup();
    // if (!this.props.popupUbication){this.props.handleDownload();}
  }
 
  render(){
    let activeSave=null;
    if(this.state.change){
      if(this.state.fileName){
        if (this.state.fileName.length > 0){
          activeSave=true;
        }
        else{
          activeSave=false;
        }
      }
      
    }else if(this.props.staticName) {
      if (this.props.staticName.length > 0){
        activeSave=true;
      }else{
        activeSave=false;
      }
    }
    return(
      <div className="file-name-popout-background">
        <div className={'file-name-popout'+ (this.props.popupUbication=='projectCloseout'?'-projectCloseout':'')} ref={el => this.deactivatePopup = el} >
          <header className="file-name-popout__header" style={{ backgroundColor: '#184E78' }} >
            <div className="caption" style={{ color: 'white' }}>
              Set File Name
            </div>
            <div className='close-button'>
              <img
                src={cancelIcon}
                alt="cancel"
                className='close-button'
                onClick={this.collapsePopup}
              />
          </div>
          </header>

          <section className='file-name-popout__container'>
            <Input
              className='file-name-input'
              name='fileName'
              value={this.state.change ? this.state.fileName ?this.state.fileName:'': this.props.staticName?this.props.staticName:''}
              placeholder={'Enter a file name'}
              onChange={this.changeFileName}
              pattern={'[A-Za-z0-9_-]{1,15}'}
            />
            
          </section>

          <div className='file-name-popout__button-container'>
        
            <button className={'cancel-button'} onClick={this.collapsePopup}>
              CANCEL
            </button> 
          
            <button className={'save-button' } style={{ backgroundColor: activeSave && this.props.attachmentIds.length>0 ? '#27ae60':'gray', border: activeSave? '#5DB348':'gray' }} 
            onClick={activeSave && this.props.attachmentIds.length>0?()=>{this.handleDownloadFile(this.props.fileUrl);} : null}  >
              SAVE   
            </button>

          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FileNamePopup/index.js